import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
